import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  createThis2j2avj17cvnv2 as createThis,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  protoOf180f3jzyo7rfj as protoOf,
  Comparable198qfk8pnblz0 as Comparable,
  KtList3hktaavzmj137 as KtList,
  toSet2orjxp16sotqu as toSet,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  isNaNymqb93xtq8w8 as isNaN_0,
  Unit_instanceat14thlj150z as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  contentEquals379bkuxwxaiqz as contentEquals,
  contentHashCode2dpr73siofp13 as contentHashCode,
  StringBuildermazzzhj6kkai as StringBuilder,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  numberToDouble210hrknaofnhf as numberToDouble,
  coerceIn10f36k81le1mm as coerceIn,
  minOfmf6w75l7u1a7 as minOf,
  maxOf1m19db8qhkqy5 as maxOf,
} from './kotlin-kotlin-stdlib.mjs';
import {
  _Ratio___init__impl__9mwvn2xyj9fjgana63 as _Ratio___init__impl__9mwvn2,
  umod1d8wj61c81r0q as umod,
  isAlmostEquals2e7wogp48cvmj as isAlmostEquals,
  Ratio__toDouble_impl_o7epze2ppsc3gplivz8 as Ratio__toDouble_impl_o7epze,
  toRatio1hooqit5gulhr as toRatio,
  Ratio__times_impl_ucdh7y2x1w5kf040xma as Ratio__times_impl_ucdh7y,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  roundDecimalPlaces1x32iuyd1l8m5 as roundDecimalPlaces,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
  IsAlmostEquals2vs54x7i426j2 as IsAlmostEquals,
  interpolate2g7wzskc23f1q as interpolate,
  interpolate35pbs3ac913y4 as interpolate_0,
  get_niceStr1tlwtz2l2j4my as get_niceStr_0,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.b24_1 = Anchor2D.m24(0.0, 0.0);
    this.c24_1 = Anchor2D.m24(0.5, 0.0);
    this.d24_1 = Anchor2D.m24(1.0, 0.0);
    this.e24_1 = Anchor2D.m24(0.0, 0.5);
    this.f24_1 = Anchor2D.m24(0.5, 0.5);
    this.g24_1 = Anchor2D.m24(1.0, 0.5);
    this.h24_1 = Anchor2D.m24(0.0, 1.0);
    this.i24_1 = Anchor2D.m24(0.5, 1.0);
    this.j24_1 = Anchor2D.m24(1.0, 1.0);
  }
  n24() {
    return this.f24_1;
  }
}
class Anchor2D {
  static o24(sx, sy) {
    Companion_getInstance();
    var $this = createThis(this);
    $this.k24_1 = sx;
    $this.l24_1 = sy;
    return $this;
  }
  p24() {
    return Vector2D.s24(this.k24_1, this.l24_1);
  }
  static m24(sx, sy) {
    Companion_getInstance();
    return this.o24(sx, sy);
  }
  toString() {
    return 'Anchor2D(sx=' + this.k24_1 + ', sy=' + this.l24_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.k24_1);
    result = imul(result, 31) + getNumberHashCode(this.l24_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Anchor2D))
      return false;
    var tmp0_other_with_cast = other instanceof Anchor2D ? other : THROW_CCE();
    if (!equals(this.k24_1, tmp0_other_with_cast.k24_1))
      return false;
    if (!equals(this.l24_1, tmp0_other_with_cast.l24_1))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio = toRatio(1.0E-5);
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio, 6.283185307179586);
    tmp.u24_1 = _Angle___init__impl__g23q1m(tmp$ret$0);
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_0 = toRatio(0.0);
    var tmp$ret$2 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    tmp_0.v24_1 = _Angle___init__impl__g23q1m(tmp$ret$2);
    var tmp_1 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_1 = toRatio(0.25);
    var tmp$ret$4 = Ratio__times_impl_ucdh7y(ratio_1, 6.283185307179586);
    tmp_1.w24_1 = _Angle___init__impl__g23q1m(tmp$ret$4);
    var tmp_2 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_2 = toRatio(0.5);
    var tmp$ret$6 = Ratio__times_impl_ucdh7y(ratio_2, 6.283185307179586);
    tmp_2.x24_1 = _Angle___init__impl__g23q1m(tmp$ret$6);
    var tmp_3 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_3 = toRatio(0.75);
    var tmp$ret$8 = Ratio__times_impl_ucdh7y(ratio_3, 6.283185307179586);
    tmp_3.y24_1 = _Angle___init__impl__g23q1m(tmp$ret$8);
    var tmp_4 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_4 = toRatio(1.0);
    var tmp$ret$10 = Ratio__times_impl_ucdh7y(ratio_4, 6.283185307179586);
    tmp_4.z24_1 = _Angle___init__impl__g23q1m(tmp$ret$10);
  }
}
class Angle {
  constructor(radians) {
    Companion_getInstance_0();
    this.t24_1 = radians;
  }
  a25(other, epsilon) {
    return Angle__isAlmostEquals_impl_201sgt(this.t24_1, other, epsilon);
  }
  sw(other, epsilon) {
    return Angle__isAlmostEquals_impl_201sgt_0(this, other, epsilon);
  }
  b25(other) {
    return Angle__compareTo_impl_a0hfds(this.t24_1, other);
  }
  d(other) {
    return Angle__compareTo_impl_a0hfds_0(this, other);
  }
  toString() {
    return Angle__toString_impl_786qky(this.t24_1);
  }
  hashCode() {
    return Angle__hashCode_impl_szcndt(this.t24_1);
  }
  equals(other) {
    return Angle__equals_impl_zcf5mt(this.t24_1, other);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    this.x25_1 = _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_12().b26());
  }
  c26() {
    return this.x25_1;
  }
  d26(p1, p2, p3, p4) {
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_12().g26(Companion_getInstance_17().e26(p1, p2, p3, p4), Companion_getInstance_17().f26(p1, p2, p3, p4)));
  }
}
class BoundsBuilder {
  constructor(bounds) {
    Companion_getInstance_1();
    this.p26_1 = bounds;
  }
  toString() {
    return BoundsBuilder__toString_impl_fmvxh7(this.p26_1);
  }
  hashCode() {
    return BoundsBuilder__hashCode_impl_649zbo(this.p26_1);
  }
  equals(other) {
    return BoundsBuilder__equals_impl_jngfjs(this.p26_1, other);
  }
}
class Companion_2 {}
class Circle {
  constructor(center, radius) {
    this.q26_1 = center;
    this.r26_1 = radius;
  }
  s26() {
    return this.r26_1 * this.r26_1;
  }
  t26(p) {
    return Companion_getInstance_17().u26(p, this.q26_1);
  }
  v26(p) {
    return this.t26(p) - this.s26();
  }
  w26(p) {
    return this.t26(p) + this.s26();
  }
  toString() {
    return 'Circle(center=' + this.q26_1.toString() + ', radius=' + this.r26_1 + ')';
  }
  hashCode() {
    var result = this.q26_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.r26_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Circle))
      return false;
    var tmp0_other_with_cast = other instanceof Circle ? other : THROW_CCE();
    if (!this.q26_1.equals(tmp0_other_with_cast.q26_1))
      return false;
    if (!equals(this.r26_1, tmp0_other_with_cast.r26_1))
      return false;
    return true;
  }
}
class IPointList$Sublist$listIterator$1 {
  constructor($index, this$0) {
    this.y26_1 = $index;
    this.z26_1 = this$0;
    this.x26_1 = $index;
  }
  b1() {
    return this.x26_1 >= this.z26_1.d27_1;
  }
  c1() {
    var _unary__edvuaz = this.x26_1;
    this.x26_1 = _unary__edvuaz + 1 | 0;
    return this.z26_1.d1(_unary__edvuaz);
  }
}
class Sublist {
  constructor(list, fromIndex, toIndex) {
    this.a27_1 = list;
    this.b27_1 = fromIndex;
    this.c27_1 = toIndex;
    this.d27_1 = this.c27_1 - this.b27_1 | 0;
  }
  e1() {
    return this.d27_1;
  }
  d1(index) {
    return this.a27_1.d1(index + this.b27_1 | 0);
  }
  g1() {
    return this.d27_1 === 0;
  }
  a1() {
    return this.w2();
  }
  w2() {
    return this.i1(0);
  }
  i1(index) {
    return new IPointList$Sublist$listIterator$1(index, this);
  }
  x2(fromIndex, toIndex) {
    return new Sublist(this.a27_1, this.b27_1 + fromIndex | 0, this.b27_1 + toIndex | 0);
  }
  e27(element) {
    return Companion_instance_3.f27(this.a27_1, element, this.b27_1, this.c27_1, -this.b27_1 | 0);
  }
  l1(element) {
    if (!(element instanceof Vector2D))
      return -1;
    return this.e27(element instanceof Vector2D ? element : THROW_CCE());
  }
  g27(elements) {
    return Companion_instance_3.h27(this, elements);
  }
  v2(elements) {
    return this.g27(elements);
  }
  i27(element) {
    return this.e27(element) >= 0;
  }
  u2(element) {
    if (!(element instanceof Vector2D))
      return false;
    return this.i27(element instanceof Vector2D ? element : THROW_CCE());
  }
}
class Companion_3 {
  h27(_this__u8e3s4, elements) {
    var s = toSet(elements);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(_this__u8e3s4, Collection)) {
        tmp = _this__u8e3s4.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = _this__u8e3s4.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.math.geom.Companion.containsAllSet.<anonymous>' call
        if (!s.u2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  f27(list, element, fromIndex, toIndex, offset) {
    var inductionVariable = fromIndex;
    if (inductionVariable < toIndex)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (list.j27(n) === element.q24_1 && list.k27(n) === element.r24_1)
          return n + offset | 0;
      }
       while (inductionVariable < toIndex);
    return -1;
  }
  l27(list, element, fromIndex, toIndex, offset, $super) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? list.e1() : toIndex;
    offset = offset === VOID ? 0 : offset;
    return $super === VOID ? this.f27(list, element, fromIndex, toIndex, offset) : $super.f27.call(this, list, element, fromIndex, toIndex, offset);
  }
}
class IDoubleVectorList {}
function isNotEmpty() {
  return !(this.e1() === 0);
}
function isAlmostEquals_0(other, epsilon) {
  if (!(this.e1() === other.e1()))
    return false;
  if (!(this.p27() === other.p27()))
    return false;
  var inductionVariable = 0;
  var last = this.p27();
  if (inductionVariable < last)
    do {
      var dim = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = this.e1();
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!isAlmostEquals(this.n27(n, dim), other.n27(n, dim), epsilon))
            return false;
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return true;
}
class IPointList {}
function get(index) {
  return Vector2D.s24(this.j27(index), this.k27(index));
}
function containsAll(elements) {
  return Companion_instance_3.h27(this, elements);
}
function indexOf(element) {
  return Companion_instance_3.l27(this, element);
}
function iterator() {
  return this.w2();
}
function listIterator() {
  return this.i1(0);
}
function listIterator_0(index) {
  return (new Sublist(this, 0, this.e1())).i1(index);
}
function subList(fromIndex, toIndex) {
  return new Sublist(this, fromIndex, toIndex);
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    this.q27_1 = Line2D.u27(Companion_getInstance_17().e25_1, Companion_getInstance_17().e25_1);
    this.r27_1 = Line2D.u27(Companion_getInstance_17().f25_1, Companion_getInstance_17().f25_1);
  }
}
class Line2D {
  static u27(a, b) {
    Companion_getInstance_4();
    var $this = createThis(this);
    $this.s27_1 = a;
    $this.t27_1 = b;
    return $this;
  }
  static v27() {
    Companion_getInstance_4();
    return this.u27(Vector2D.w27(), Vector2D.w27());
  }
  static x27(x0, y0, x1, y1) {
    Companion_getInstance_4();
    return this.u27(Vector2D.y27(x0, y0), Vector2D.y27(x1, y1));
  }
  z27() {
    return this.s27_1.q24_1;
  }
  a28() {
    return this.s27_1.r24_1;
  }
  b28() {
    return this.t27_1.q24_1;
  }
  c28() {
    return this.t27_1.r24_1;
  }
  toString() {
    return 'Line(' + this.s27_1.toString() + ', ' + this.t27_1.toString() + ')';
  }
  hashCode() {
    var result = this.s27_1.hashCode();
    result = imul(result, 31) + this.t27_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line2D))
      return false;
    var tmp0_other_with_cast = other instanceof Line2D ? other : THROW_CCE();
    if (!this.s27_1.equals(tmp0_other_with_cast.s27_1))
      return false;
    if (!this.t27_1.equals(tmp0_other_with_cast.t27_1))
      return false;
    return true;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_5 = this;
    this.d28_1 = Margin.i28(0.0, 0.0, 0.0, 0.0);
  }
}
class Margin {
  static i28(top, right, bottom, left) {
    Companion_getInstance_5();
    var $this = createThis(this);
    $this.e28_1 = top;
    $this.f28_1 = right;
    $this.g28_1 = bottom;
    $this.h28_1 = left;
    return $this;
  }
  static j28(margin) {
    Companion_getInstance_5();
    return this.i28(margin, margin, margin, margin);
  }
  k28(other, epsilon) {
    return isAlmostEquals(this.h28_1, other.h28_1, epsilon) && isAlmostEquals(this.f28_1, other.f28_1, epsilon) && isAlmostEquals(this.e28_1, other.e28_1, epsilon) && isAlmostEquals(this.g28_1, other.g28_1, epsilon);
  }
  sw(other, epsilon) {
    return this.k28(other instanceof Margin ? other : THROW_CCE(), epsilon);
  }
  l28() {
    return this.h28_1 + this.f28_1;
  }
  m28() {
    return this.e28_1 + this.g28_1;
  }
  toString() {
    return 'Margin(top=' + get_niceStr(this.e28_1) + ', right=' + get_niceStr(this.f28_1) + ', bottom=' + get_niceStr(this.g28_1) + ', left=' + get_niceStr(this.h28_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.e28_1);
    result = imul(result, 31) + getNumberHashCode(this.f28_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.g28_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h28_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Margin))
      return false;
    var tmp0_other_with_cast = other instanceof Margin ? other : THROW_CCE();
    if (!equals(this.e28_1, tmp0_other_with_cast.e28_1))
      return false;
    if (!equals(this.f28_1, tmp0_other_with_cast.f28_1))
      return false;
    if (!equals(this.g28_1, tmp0_other_with_cast.g28_1))
      return false;
    if (!equals(this.h28_1, tmp0_other_with_cast.h28_1))
      return false;
    return true;
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_6 = this;
    this.n28_1 = MarginInt.s28(0, 0, 0, 0);
  }
}
class MarginInt {
  static s28(top, right, bottom, left) {
    Companion_getInstance_6();
    var $this = createThis(this);
    $this.o28_1 = top;
    $this.p28_1 = right;
    $this.q28_1 = bottom;
    $this.r28_1 = left;
    return $this;
  }
  static t28(vertical, horizontal) {
    Companion_getInstance_6();
    return this.s28(vertical, horizontal, vertical, horizontal);
  }
  static u28(margin) {
    Companion_getInstance_6();
    return this.s28(margin, margin, margin, margin);
  }
  v28() {
    return !(this.o28_1 === 0) || !(this.r28_1 === 0) || !(this.p28_1 === 0) || !(this.q28_1 === 0);
  }
  l28() {
    return this.r28_1 + this.p28_1 | 0;
  }
  m28() {
    return this.o28_1 + this.q28_1 | 0;
  }
  toString() {
    return 'MarginInt(top=' + this.o28_1 + ', right=' + this.p28_1 + ', bottom=' + this.q28_1 + ', left=' + this.r28_1 + ')';
  }
  hashCode() {
    var result = this.o28_1;
    result = imul(result, 31) + this.p28_1 | 0;
    result = imul(result, 31) + this.q28_1 | 0;
    result = imul(result, 31) + this.r28_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MarginInt))
      return false;
    var tmp0_other_with_cast = other instanceof MarginInt ? other : THROW_CCE();
    if (!(this.o28_1 === tmp0_other_with_cast.o28_1))
      return false;
    if (!(this.p28_1 === tmp0_other_with_cast.p28_1))
      return false;
    if (!(this.q28_1 === tmp0_other_with_cast.q28_1))
      return false;
    if (!(this.r28_1 === tmp0_other_with_cast.r28_1))
      return false;
    return true;
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_7 = this;
    this.w28_1 = new Matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
    this.x28_1 = new Matrix(NaN, NaN, NaN, NaN, NaN, NaN);
    this.y28_1 = this.x28_1;
  }
  z28() {
    return this.w28_1;
  }
  a29(a, b, epsilon) {
    return isAlmostEquals(a.f29_1, b.f29_1, epsilon) && isAlmostEquals(a.g29_1, b.g29_1, epsilon) && isAlmostEquals(a.b29_1, b.b29_1, epsilon) && isAlmostEquals(a.c29_1, b.c29_1, epsilon) && isAlmostEquals(a.d29_1, b.d29_1, epsilon) && isAlmostEquals(a.e29_1, b.e29_1, epsilon);
  }
  h29(l, r) {
    if (l.r25())
      return r;
    if (r.r25())
      return l;
    return new Matrix(l.b29_1 * r.b29_1 + l.c29_1 * r.d29_1, l.b29_1 * r.c29_1 + l.c29_1 * r.e29_1, l.d29_1 * r.b29_1 + l.e29_1 * r.d29_1, l.d29_1 * r.c29_1 + l.e29_1 * r.e29_1, l.f29_1 * r.b29_1 + l.g29_1 * r.d29_1 + r.f29_1, l.f29_1 * r.c29_1 + l.g29_1 * r.e29_1 + r.g29_1);
  }
  i29(x, y, rotation, scaleX, scaleY, skewX, skewY, pivotX, pivotY) {
    // Inline function 'korlibs.math.geom.cos' call
    var angle = Angle__plus_impl_26v37k(rotation, skewY);
    var up = Companion_getInstance_17().i25_1;
    var a = Angle__cosine_impl_bgvzun(angle, up) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_0 = Angle__plus_impl_26v37k(rotation, skewY);
    var up_0 = Companion_getInstance_17().i25_1;
    var b = Angle__sine_impl_3l11xv(angle_0, up_0) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_1 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_1 = Companion_getInstance_17().i25_1;
    var c = -Angle__sine_impl_3l11xv(angle_1, up_1) * scaleY + 0.0;
    // Inline function 'korlibs.math.geom.cos' call
    var angle_2 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_2 = Companion_getInstance_17().i25_1;
    var d = Angle__cosine_impl_bgvzun(angle_2, up_2) * scaleY + 0.0;
    var tx;
    var ty;
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = x;
      ty = y;
    } else {
      tx = x - (pivotX * a + pivotY * c);
      ty = y - (pivotX * b + pivotY * d);
    }
    return new Matrix(a, b, c, d, tx, ty);
  }
  j29(a, b, c, d, tx, ty, p) {
    return Vector2D.s24(a * p.q24_1 + c * p.r24_1 + tx, d * p.r24_1 + b * p.q24_1 + ty);
  }
}
class Matrix {
  constructor(a, b, c, d, tx, ty) {
    Companion_getInstance_7();
    tx = tx === VOID ? 0.0 : tx;
    ty = ty === VOID ? 0.0 : ty;
    this.b29_1 = a;
    this.c29_1 = b;
    this.d29_1 = c;
    this.e29_1 = d;
    this.f29_1 = tx;
    this.g29_1 = ty;
  }
  k29(other) {
    return Companion_getInstance_7().h29(this, other);
  }
  r25() {
    return isNaN_0(this.b29_1);
  }
  s25() {
    return !this.r25();
  }
  l29() {
    return this.b29_1 === 1.0 && this.c29_1 === 0.0 && this.d29_1 === 0.0 && this.e29_1 === 1.0 && this.f29_1 === 0.0 && this.g29_1 === 0.0;
  }
  m29() {
    var hasRotation = !(this.c29_1 === 0.0) || !(this.d29_1 === 0.0);
    var hasScale = !(this.b29_1 === 1.0) || !(this.e29_1 === 1.0);
    var hasTranslation = !(this.f29_1 === 0.0) || !(this.g29_1 === 0.0);
    return hasRotation ? MatrixType_COMPLEX_getInstance() : hasScale && hasTranslation ? MatrixType_SCALE_TRANSLATE_getInstance() : hasScale ? MatrixType_SCALE_getInstance() : hasTranslation ? MatrixType_TRANSLATE_getInstance() : MatrixType_IDENTITY_getInstance();
  }
  n29(p) {
    return this.o29(p.q24_1, p.r24_1);
  }
  p29(x, y) {
    return this.o29(x, y);
  }
  q29(x, y) {
    return this.r29(x, y);
  }
  o29(x, y) {
    return this.b29_1 * x + this.d29_1 * y + this.f29_1;
  }
  r29(x, y) {
    return this.e29_1 * y + this.c29_1 * x + this.g29_1;
  }
  s29(x, y) {
    return this.o29(x, y);
  }
  t29(x, y) {
    return this.r29(x, y);
  }
  u29(angle) {
    // Inline function 'korlibs.math.geom.cos' call
    var up = Companion_getInstance_17().i25_1;
    var cos = Angle__cosine_impl_bgvzun(angle, up);
    // Inline function 'korlibs.math.geom.sin' call
    var up_0 = Companion_getInstance_17().i25_1;
    var sin = Angle__sine_impl_3l11xv(angle, up_0);
    var a1 = this.b29_1 * cos - this.c29_1 * sin;
    var b = this.b29_1 * sin + this.c29_1 * cos;
    var a = a1;
    var c1 = this.d29_1 * cos - this.e29_1 * sin;
    var d = this.d29_1 * sin + this.e29_1 * cos;
    var c = c1;
    var tx1 = this.f29_1 * cos - this.g29_1 * sin;
    var ty = this.f29_1 * sin + this.g29_1 * cos;
    var tx = tx1;
    return new Matrix(a, b, c, d, tx, ty);
  }
  v29(scaleX, scaleY) {
    return this.w29(scaleX, scaleY);
  }
  w29(scaleX, scaleY) {
    return new Matrix(this.b29_1 * scaleX, this.c29_1 * scaleX, this.d29_1 * scaleY, this.e29_1 * scaleY, this.f29_1 * scaleX, this.g29_1 * scaleY);
  }
  x29(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.w29(scaleX, scaleY) : $super.w29.call(this, scaleX, scaleY);
  }
  y29(scaleX, scaleY) {
    return new Matrix(this.b29_1 * scaleX, this.c29_1 * scaleX, this.d29_1 * scaleY, this.e29_1 * scaleY, this.f29_1, this.g29_1);
  }
  z29(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.y29(scaleX, scaleY) : $super.y29.call(this, scaleX, scaleY);
  }
  a2a(delta) {
    return new Matrix(this.b29_1, this.c29_1, this.d29_1, this.e29_1, this.f29_1 + delta.q24_1, this.g29_1 + delta.r24_1);
  }
  b2a(x, y) {
    return this.a2a(Vector2D.y27(x, y));
  }
  c2a(x, y) {
    return this.a2a(Vector2D.s24(x, y));
  }
  d2a(delta) {
    return new Matrix(this.b29_1, this.c29_1, this.d29_1, this.e29_1, this.f29_1 + (this.b29_1 * delta.q24_1 + this.d29_1 * delta.r24_1), this.g29_1 + (this.c29_1 * delta.q24_1 + this.e29_1 * delta.r24_1));
  }
  e2a(deltaX, deltaY) {
    return this.d2a(Vector2D.y27(deltaX, deltaY));
  }
  f2a(deltaX, deltaY) {
    return this.d2a(Vector2D.g2a(deltaX, deltaY));
  }
  h2a(deltaX, deltaY) {
    return this.d2a(Vector2D.s24(deltaX, deltaY));
  }
  i2a(m) {
    return m.k29(this);
  }
  j2a() {
    if (this.r25())
      return Companion_getInstance_7().w28_1;
    var m = this;
    var norm = m.b29_1 * m.e29_1 - m.c29_1 * m.d29_1;
    var tmp;
    if (norm === 0.0) {
      tmp = new Matrix(0.0, 0.0, 0.0, 0.0, -m.f29_1, -m.g29_1);
    } else {
      var inorm = 1.0 / norm;
      var d = m.b29_1 * inorm;
      var a = m.e29_1 * inorm;
      var b = m.c29_1 * -inorm;
      var c = m.d29_1 * -inorm;
      tmp = new Matrix(a, b, c, d, -a * m.f29_1 - c * m.g29_1, -b * m.f29_1 - d * m.g29_1);
    }
    return tmp;
  }
  k2a() {
    return this.l2a();
  }
  l2a() {
    return Companion_getInstance_8().n2a(this);
  }
  toString() {
    return 'Matrix(' + get_niceStr(this.b29_1) + ', ' + get_niceStr(this.c29_1) + ', ' + get_niceStr(this.d29_1) + ', ' + get_niceStr(this.e29_1) + ', ' + get_niceStr(this.f29_1) + ', ' + get_niceStr(this.g29_1) + ')';
  }
  o2a(other, epsilon) {
    return Companion_getInstance_7().a29(this, other, epsilon);
  }
  sw(other, epsilon) {
    return this.o2a(other instanceof Matrix ? other : THROW_CCE(), epsilon);
  }
  p2a(other) {
    return this.k29(other);
  }
  hashCode() {
    var result = getNumberHashCode(this.b29_1);
    result = imul(result, 31) + getNumberHashCode(this.c29_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d29_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e29_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.f29_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.g29_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Matrix))
      return false;
    var tmp0_other_with_cast = other instanceof Matrix ? other : THROW_CCE();
    if (!equals(this.b29_1, tmp0_other_with_cast.b29_1))
      return false;
    if (!equals(this.c29_1, tmp0_other_with_cast.c29_1))
      return false;
    if (!equals(this.d29_1, tmp0_other_with_cast.d29_1))
      return false;
    if (!equals(this.e29_1, tmp0_other_with_cast.e29_1))
      return false;
    if (!equals(this.f29_1, tmp0_other_with_cast.f29_1))
      return false;
    if (!equals(this.g29_1, tmp0_other_with_cast.g29_1))
      return false;
    return true;
  }
}
class MatrixType extends Enum {
  constructor(name, ordinal, id, hasRotation, hasScale, hasTranslation) {
    super(name, ordinal);
    this.s2a_1 = id;
    this.t2a_1 = hasRotation;
    this.u2a_1 = hasScale;
    this.v2a_1 = hasTranslation;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_8 = this;
    this.m2a_1 = MatrixTransform.d2b(0.0, 0.0, 1.0, 1.0, Companion_getInstance_0().v24_1, Companion_getInstance_0().v24_1, Companion_getInstance_0().v24_1);
  }
  e2b(matrix, pivotX, pivotY) {
    var a = matrix.b29_1;
    var b = matrix.c29_1;
    var c = matrix.d29_1;
    var d = matrix.e29_1;
    // Inline function 'kotlin.math.atan2' call
    var y = -c;
    var skewX = -Math.atan2(y, d);
    // Inline function 'kotlin.math.atan2' call
    var skewY = Math.atan2(b, a);
    // Inline function 'kotlin.math.abs' call
    var x = skewX + skewY;
    var delta = Math.abs(x);
    var trotation;
    var tskewX;
    var tskewY;
    var tx;
    var ty;
    var tmp;
    if (delta < 0.001) {
      tmp = true;
    } else {
      // Inline function 'kotlin.math.abs' call
      var x_0 = 3.141592653589793 * 2 - delta;
      tmp = Math.abs(x_0) < 0.001;
    }
    if (tmp) {
      trotation = get_radians_0(skewY);
      tskewX = get_radians_0(0.0);
      tskewY = get_radians_0(0.0);
    } else {
      trotation = get_radians(0);
      tskewX = get_radians_0(skewX);
      tskewY = get_radians_0(skewY);
    }
    // Inline function 'kotlin.math.hypot' call
    var tscaleX = hypot(a, b);
    // Inline function 'kotlin.math.hypot' call
    var tscaleY = hypot(c, d);
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = matrix.f29_1;
      ty = matrix.g29_1;
    } else {
      tx = matrix.f29_1 + (pivotX * a + pivotY * c);
      ty = matrix.g29_1 + (pivotX * b + pivotY * d);
    }
    return MatrixTransform.d2b(tx, ty, tscaleX, tscaleY, tskewX, tskewY, trotation);
  }
  n2a(matrix, pivotX, pivotY, $super) {
    pivotX = pivotX === VOID ? 0.0 : pivotX;
    pivotY = pivotY === VOID ? 0.0 : pivotY;
    return $super === VOID ? this.e2b(matrix, pivotX, pivotY) : $super.e2b.call(this, matrix, pivotX, pivotY);
  }
  f2b(a, b, epsilon) {
    return isAlmostEquals(a.w2a_1, b.w2a_1, epsilon) && isAlmostEquals(a.x2a_1, b.x2a_1, epsilon) && isAlmostEquals(a.y2a_1, b.y2a_1, epsilon) && isAlmostEquals(a.z2a_1, b.z2a_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.a2b_1, b.a2b_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.b2b_1, b.b2b_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.c2b_1, b.c2b_1, epsilon);
  }
}
class MatrixTransform {
  static d2b(x, y, scaleX, scaleY, skewX, skewY, rotation) {
    Companion_getInstance_8();
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    scaleX = scaleX === VOID ? 1.0 : scaleX;
    scaleY = scaleY === VOID ? 1.0 : scaleY;
    skewX = skewX === VOID ? Companion_getInstance_0().v24_1 : skewX;
    skewY = skewY === VOID ? Companion_getInstance_0().v24_1 : skewY;
    rotation = rotation === VOID ? Companion_getInstance_0().v24_1 : rotation;
    var $this = createThis(this);
    $this.w2a_1 = x;
    $this.x2a_1 = y;
    $this.y2a_1 = scaleX;
    $this.z2a_1 = scaleY;
    $this.a2b_1 = skewX;
    $this.b2b_1 = skewY;
    $this.c2b_1 = rotation;
    return $this;
  }
  toString() {
    return 'MatrixTransform(x=' + get_niceStr(this.w2a_1) + ', y=' + get_niceStr(this.x2a_1) + ', scaleX=' + this.y2a_1 + ', scaleY=' + this.z2a_1 + ', skewX=' + Angle__toString_impl_786qky(this.a2b_1) + ', skewY=' + Angle__toString_impl_786qky(this.b2b_1) + ', rotation=' + Angle__toString_impl_786qky(this.c2b_1) + ')';
  }
  static g2b() {
    Companion_getInstance_8();
    return this.d2b(0.0, 0.0, 1.0, 1.0, Companion_getInstance_0().v24_1, Companion_getInstance_0().v24_1, Companion_getInstance_0().v24_1);
  }
  h2b(other, epsilon) {
    return Companion_getInstance_8().f2b(this, other, epsilon);
  }
  sw(other, epsilon) {
    return this.h2b(other instanceof MatrixTransform ? other : THROW_CCE(), epsilon);
  }
  i2b() {
    return (this.y2a_1 + this.z2a_1) * 0.5;
  }
  hashCode() {
    var result = getNumberHashCode(this.w2a_1);
    result = imul(result, 31) + getNumberHashCode(this.x2a_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y2a_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z2a_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.a2b_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.b2b_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.c2b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MatrixTransform))
      return false;
    var tmp0_other_with_cast = other instanceof MatrixTransform ? other : THROW_CCE();
    if (!equals(this.w2a_1, tmp0_other_with_cast.w2a_1))
      return false;
    if (!equals(this.x2a_1, tmp0_other_with_cast.x2a_1))
      return false;
    if (!equals(this.y2a_1, tmp0_other_with_cast.y2a_1))
      return false;
    if (!equals(this.z2a_1, tmp0_other_with_cast.z2a_1))
      return false;
    if (!equals(this.a2b_1, tmp0_other_with_cast.a2b_1))
      return false;
    if (!equals(this.b2b_1, tmp0_other_with_cast.b2b_1))
      return false;
    if (!equals(this.c2b_1, tmp0_other_with_cast.c2b_1))
      return false;
    return true;
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_9 = this;
    this.j2b_1 = 0;
    this.k2b_1 = 1;
    this.l2b_1 = 2;
    this.m2b_1 = 3;
    this.n2b_1 = 4;
    this.o2b_1 = 5;
    this.p2b_1 = 6;
    this.q2b_1 = 7;
    this.r2b_1 = 8;
    this.s2b_1 = 9;
    this.t2b_1 = 10;
    this.u2b_1 = 11;
    this.v2b_1 = 12;
    this.w2b_1 = 13;
    this.x2b_1 = 14;
    this.y2b_1 = 15;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp.z2b_1 = new Int32Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
    var tmp_0 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_0.a2c_1 = new Int32Array([0, 4, 8, 12, 1, 5, 9, 13, 2, 6, 10, 14, 3, 7, 11, 15]);
    var tmp_1 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_1.b2c_1 = new Int32Array([0, 1, 2, 4, 5, 6, 8, 9, 10]);
    var tmp_2 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_2.c2c_1 = new Int32Array([0, 4, 8, 1, 5, 9, 2, 6, 10]);
    this.d2c_1 = Matrix4.f2c();
  }
  g2c(v00, v01, v02, v03, v10, v11, v12, v13, v20, v21, v22, v23, v30, v31, v32, v33) {
    return Matrix4.h2c(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33);
  }
  i2c(l, r) {
    return Companion_getInstance_9().g2c(l.j2c() * r.j2c() + l.k2c() * r.l2c() + l.m2c() * r.n2c() + l.o2c() * r.p2c(), l.j2c() * r.k2c() + l.k2c() * r.q2c() + l.m2c() * r.r2c() + l.o2c() * r.s2c(), l.j2c() * r.m2c() + l.k2c() * r.t2c() + l.m2c() * r.u2c() + l.o2c() * r.v2c(), l.j2c() * r.o2c() + l.k2c() * r.w2c() + l.m2c() * r.x2c() + l.o2c() * r.y2c(), l.l2c() * r.j2c() + l.q2c() * r.l2c() + l.t2c() * r.n2c() + l.w2c() * r.p2c(), l.l2c() * r.k2c() + l.q2c() * r.q2c() + l.t2c() * r.r2c() + l.w2c() * r.s2c(), l.l2c() * r.m2c() + l.q2c() * r.t2c() + l.t2c() * r.u2c() + l.w2c() * r.v2c(), l.l2c() * r.o2c() + l.q2c() * r.w2c() + l.t2c() * r.x2c() + l.w2c() * r.y2c(), l.n2c() * r.j2c() + l.r2c() * r.l2c() + l.u2c() * r.n2c() + l.x2c() * r.p2c(), l.n2c() * r.k2c() + l.r2c() * r.q2c() + l.u2c() * r.r2c() + l.x2c() * r.s2c(), l.n2c() * r.m2c() + l.r2c() * r.t2c() + l.u2c() * r.u2c() + l.x2c() * r.v2c(), l.n2c() * r.o2c() + l.r2c() * r.w2c() + l.u2c() * r.x2c() + l.x2c() * r.y2c(), l.p2c() * r.j2c() + l.s2c() * r.l2c() + l.v2c() * r.n2c() + l.y2c() * r.p2c(), l.p2c() * r.k2c() + l.s2c() * r.q2c() + l.v2c() * r.r2c() + l.y2c() * r.s2c(), l.p2c() * r.m2c() + l.s2c() * r.t2c() + l.v2c() * r.u2c() + l.y2c() * r.v2c(), l.p2c() * r.o2c() + l.s2c() * r.w2c() + l.v2c() * r.x2c() + l.y2c() * r.y2c());
  }
  z2c(left, right, bottom, top, near, far) {
    var sx = 2.0 / (right - left);
    var sy = 2.0 / (top - bottom);
    var sz = -2.0 / (far - near);
    var tx = -(right + left) / (right - left);
    var ty = -(top + bottom) / (top - bottom);
    var tz = -(far + near) / (far - near);
    return Companion_getInstance_9().g2c(sx, 0.0, 0.0, tx, 0.0, sy, 0.0, ty, 0.0, 0.0, sz, tz, 0.0, 0.0, 0.0, 1.0);
  }
  a2d(left, right, bottom, top, near, far) {
    return this.z2c(left, right, bottom, top, near, far);
  }
}
class Matrix4 {
  static b2d(data) {
    Companion_getInstance_9();
    var $this = createThis(this);
    $this.e2c_1 = data;
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!($this.e2c_1.length === 16)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.t4(toString(message));
    }
    return $this;
  }
  j2c() {
    return this.e2c_1[0];
  }
  l2c() {
    return this.e2c_1[1];
  }
  n2c() {
    return this.e2c_1[2];
  }
  p2c() {
    return this.e2c_1[3];
  }
  k2c() {
    return this.e2c_1[4];
  }
  q2c() {
    return this.e2c_1[5];
  }
  r2c() {
    return this.e2c_1[6];
  }
  s2c() {
    return this.e2c_1[7];
  }
  m2c() {
    return this.e2c_1[8];
  }
  t2c() {
    return this.e2c_1[9];
  }
  u2c() {
    return this.e2c_1[10];
  }
  v2c() {
    return this.e2c_1[11];
  }
  o2c() {
    return this.e2c_1[12];
  }
  w2c() {
    return this.e2c_1[13];
  }
  x2c() {
    return this.e2c_1[14];
  }
  y2c() {
    return this.e2c_1[15];
  }
  equals(other) {
    var tmp;
    if (other instanceof Matrix4) {
      tmp = contentEquals(this.e2c_1, other.e2c_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode(this.e2c_1);
  }
  c2d(that) {
    return Companion_getInstance_9().i2c(this, that);
  }
  static h2c(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33) {
    Companion_getInstance_9();
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33]);
    return this.b2d(tmp$ret$0);
  }
  static f2c() {
    Companion_getInstance_9();
    return this.h2c(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
  }
  n27(row, column) {
    if (!(0 <= column ? column <= 3 : false) || !(0 <= row ? row <= 3 : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + row + ',' + column;
      throw IllegalStateException.t4(toString(message));
    }
    return this.e2c_1[imul(row, 4) + column | 0];
  }
  d2d(index) {
    if (!(0 <= index ? index <= (this.e2c_1.length - 1 | 0) : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + index;
      throw IllegalStateException.t4(toString(message));
    }
    return this.e2c_1[index];
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.Matrix4.toString.<anonymous>' call
    this_0.mb('Matrix4(\n');
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var row = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.mb('  [ ');
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var col = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(col === 0)) {
              this_0.mb(', ');
            }
            var v = this.n27(row, col);
            // Inline function 'kotlin.math.floor' call
            if (Math.floor(v) === v)
              this_0.pg(numberToInt(v));
            else {
              this_0.rg(v);
            }
          }
           while (inductionVariable_0 < 4);
        this_0.mb(' ],\n');
      }
       while (inductionVariable < 4);
    this_0.mb(')');
    return this_0.toString();
  }
}
class Companion_10 {
  constructor() {
    this.c25_1 = 1.0E-7;
  }
  d25(up) {
    // Inline function 'kotlin.check' call
    var tmp;
    if (up.q24_1 === 0.0) {
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = up.r24_1;
      tmp = Math.abs(this_0) === 1.0;
    } else {
      tmp = false;
    }
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp) {
      // Inline function 'korlibs.math.geom.Companion.checkValidUpVector.<anonymous>' call
      var message = 'up vector only supports (0, -1) and (0, +1) for now';
      throw IllegalStateException.t4(toString(message));
    }
  }
}
class Orientation extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.j2d_1 = value;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_11 = this;
    var tmp = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    tmp.k2d_1 = new RectCorners(numberToDouble(0), numberToDouble(0), numberToDouble(0), numberToDouble(0));
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    tmp_0.l2d_1 = new RectCorners(numberToDouble(0), numberToDouble(0), numberToDouble(0), numberToDouble(0));
    var tmp_1 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    tmp_1.m2d_1 = new RectCorners(numberToDouble(1.0), numberToDouble(1.0), numberToDouble(1.0), numberToDouble(1.0));
    var tmp_2 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var corner = -1.0;
    tmp_2.n2d_1 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
    var tmp_3 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    tmp_3.o2d_1 = new RectCorners(numberToDouble(NaN), numberToDouble(NaN), numberToDouble(NaN), numberToDouble(NaN));
  }
}
class RectCorners {
  constructor(topLeft, topRight, bottomRight, bottomLeft) {
    Companion_getInstance_11();
    this.p2d_1 = topLeft;
    this.q2d_1 = topRight;
    this.r2d_1 = bottomRight;
    this.s2d_1 = bottomLeft;
  }
  t2d(scale) {
    return new RectCorners(this.p2d_1 * scale, this.q2d_1 * scale, this.r2d_1 * scale, this.s2d_1 * scale);
  }
  toString() {
    return 'RectCorners(topLeft=' + this.p2d_1 + ', topRight=' + this.q2d_1 + ', bottomRight=' + this.r2d_1 + ', bottomLeft=' + this.s2d_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.p2d_1);
    result = imul(result, 31) + getNumberHashCode(this.q2d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r2d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s2d_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectCorners))
      return false;
    var tmp0_other_with_cast = other instanceof RectCorners ? other : THROW_CCE();
    if (!equals(this.p2d_1, tmp0_other_with_cast.p2d_1))
      return false;
    if (!equals(this.q2d_1, tmp0_other_with_cast.q2d_1))
      return false;
    if (!equals(this.r2d_1, tmp0_other_with_cast.r2d_1))
      return false;
    if (!equals(this.s2d_1, tmp0_other_with_cast.s2d_1))
      return false;
    return true;
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_12 = this;
    this.y25_1 = Companion_getInstance_12().u2d(0, 0, 0, 0);
    this.z25_1 = Companion_getInstance_12().v2d(-Infinity, -Infinity, Infinity, Infinity);
    this.a26_1 = Companion_getInstance_12().v2d(NaN, NaN, 0.0, 0.0);
  }
  b26() {
    return this.a26_1;
  }
  z28() {
    return this.y25_1;
  }
  k26(p, s) {
    return new Rectangle(p.q24_1, p.r24_1, s.h26_1, s.i26_1);
  }
  u2d(x, y, width, height) {
    return Companion_getInstance_12().k26(Vector2D.y27(x, y), Size2D.j26(width, height));
  }
  v2d(x, y, width, height) {
    return Companion_getInstance_12().k26(Vector2D.g2a(x, y), Size2D.w2d(width, height));
  }
  x2d(left, top, right, bottom) {
    return new Rectangle(left, top, right - left, bottom - top);
  }
  y2d(left, top, right, bottom) {
    return this.x2d(left, top, right, bottom);
  }
  g26(point1, point2) {
    var tmp = Companion_getInstance_12();
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var tmp$ret$0 = Vector2D.s24(point2.q24_1 - point1.q24_1, point2.r24_1 - point1.r24_1);
    return tmp.k26(point1, toSize(tmp$ret$0));
  }
  z2d(a, b) {
    return a.m25_1 >= b.m25_1 && a.n25_1 >= b.n25_1 && a.m25_1 + a.o25_1 <= b.m25_1 + b.o25_1 && a.n25_1 + a.p25_1 <= b.n25_1 + b.p25_1;
  }
}
class Rectangle {
  constructor(x, y, width, height) {
    Companion_getInstance_12();
    this.m25_1 = x;
    this.n25_1 = y;
    this.o25_1 = width;
    this.p25_1 = height;
    this.q25_1 = true;
  }
  kx() {
    return this;
  }
  e1() {
    return Size2D.a2e(this.o25_1, this.p25_1);
  }
  b2e() {
    return isNaN_0(this.m25_1);
  }
  r25() {
    return this.b2e();
  }
  s25() {
    return !this.r25();
  }
  c2e(other, epsilon) {
    return isAlmostEquals(this.m25_1, other.m25_1, epsilon) && isAlmostEquals(this.n25_1, other.n25_1, epsilon) && isAlmostEquals(this.o25_1, other.o25_1, epsilon) && isAlmostEquals(this.p25_1, other.p25_1, epsilon);
  }
  sw(other, epsilon) {
    return this.c2e(other instanceof Rectangle ? other : THROW_CCE(), epsilon);
  }
  toString() {
    return this.r25() ? 'null' : 'Rectangle(x=' + get_niceStr(this.m25_1) + ', y=' + get_niceStr(this.n25_1) + ', width=' + get_niceStr(this.o25_1) + ', height=' + get_niceStr(this.p25_1) + ')';
  }
  t2d(scale) {
    return new Rectangle(this.m25_1 * scale, this.n25_1 * scale, this.o25_1 * scale, this.p25_1 * scale);
  }
  i27(that) {
    return this.d2e(that.q24_1, that.r24_1);
  }
  d2e(x, y) {
    return x >= this.t25() && x < this.u25() && (y >= this.v25() && y < this.w25());
  }
  t25() {
    return this.m25_1;
  }
  v25() {
    return this.n25_1;
  }
  u25() {
    return this.m25_1 + this.o25_1;
  }
  w25() {
    return this.n25_1 + this.p25_1;
  }
  l26() {
    return Vector2D.s24(this.t25(), this.v25());
  }
  e2e() {
    return Vector2D.s24(this.u25(), this.v25());
  }
  f2e() {
    return Vector2D.s24(this.t25(), this.w25());
  }
  n26() {
    return Vector2D.s24(this.u25(), this.w25());
  }
  g2e() {
    return (this.u25() + this.t25()) * 0.5;
  }
  h2e() {
    return (this.w25() + this.v25()) * 0.5;
  }
  i2e() {
    return Vector2D.s24(this.g2e(), this.h2e());
  }
  j2e(that) {
    return this.k2e(that) && this.l2e(that);
  }
  k2e(that) {
    return that.t25() <= this.u25() && that.u25() >= this.t25();
  }
  l2e(that) {
    return that.v25() <= this.w25() && that.w25() >= this.v25();
  }
  m2e(that) {
    var tmp;
    if (this.j2e(that)) {
      // Inline function 'kotlin.math.max' call
      var a = this.t25();
      var b = that.t25();
      var tmp_0 = Math.max(a, b);
      // Inline function 'kotlin.math.max' call
      var a_0 = this.v25();
      var b_0 = that.v25();
      var tmp_1 = Math.max(a_0, b_0);
      // Inline function 'kotlin.math.min' call
      var a_1 = this.u25();
      var b_1 = that.u25();
      var tmp_2 = Math.min(a_1, b_1);
      // Inline function 'kotlin.math.min' call
      var a_2 = this.w25();
      var b_2 = that.w25();
      var tmp$ret$3 = Math.min(a_2, b_2);
      tmp = new Rectangle(tmp_0, tmp_1, tmp_2, tmp$ret$3);
    } else {
      tmp = Companion_getInstance_12().b26();
    }
    return tmp;
  }
  g2() {
    return RectangleInt.r2e(numberToInt(this.m25_1), numberToInt(this.n25_1), numberToInt(this.o25_1), numberToInt(this.p25_1));
  }
  s2e(border) {
    return Companion_getInstance_12().x2d(this.t25() - border.r28_1, this.v25() - border.o28_1, this.u25() + border.p28_1, this.w25() + border.q28_1);
  }
  a2a(delta) {
    return this.t2e(this.m25_1 + delta.q24_1, this.n25_1 + delta.r24_1);
  }
  u2e(m) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = this.l26();
      if (m.r25()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.s24(m.o29(p.q24_1, p.r24_1), m.r29(p.q24_1, p.r24_1));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_0 = this.e2e();
      if (m.r25()) {
        tmp$ret$1 = p_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.s24(m.o29(p_0.q24_1, p_0.r24_1), m.r29(p_0.q24_1, p_0.r24_1));
    }
    var tr = tmp$ret$1;
    var tmp$ret$2;
    $l$block_1: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_1 = this.f2e();
      if (m.r25()) {
        tmp$ret$2 = p_1;
        break $l$block_1;
      }
      tmp$ret$2 = Vector2D.s24(m.o29(p_1.q24_1, p_1.r24_1), m.r29(p_1.q24_1, p_1.r24_1));
    }
    var bl = tmp$ret$2;
    var tmp$ret$3;
    $l$block_2: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_2 = this.n26();
      if (m.r25()) {
        tmp$ret$3 = p_2;
        break $l$block_2;
      }
      tmp$ret$3 = Vector2D.s24(m.o29(p_2.q24_1, p_2.r24_1), m.r29(p_2.q24_1, p_2.r24_1));
    }
    var br = tmp$ret$3;
    var min = Companion_getInstance_17().e26(tl, tr, bl, br);
    var max = Companion_getInstance_17().f26(tl, tr, bl, br);
    return Companion_getInstance_12().g26(min, max);
  }
  v2e() {
    return Companion_getInstance_12().g26(Companion_getInstance_17().m26(this.l26(), this.n26()), Companion_getInstance_17().o26(this.l26(), this.n26()));
  }
  w2e(x, y, width, height) {
    return new Rectangle(x, y, width, height);
  }
  t2e(x, y, width, height, $super) {
    x = x === VOID ? this.m25_1 : x;
    y = y === VOID ? this.n25_1 : y;
    width = width === VOID ? this.o25_1 : width;
    height = height === VOID ? this.p25_1 : height;
    return $super === VOID ? this.w2e(x, y, width, height) : $super.w2e.call(this, x, y, width, height);
  }
  hashCode() {
    var result = getNumberHashCode(this.m25_1);
    result = imul(result, 31) + getNumberHashCode(this.n25_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o25_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p25_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Rectangle))
      return false;
    var tmp0_other_with_cast = other instanceof Rectangle ? other : THROW_CCE();
    if (!equals(this.m25_1, tmp0_other_with_cast.m25_1))
      return false;
    if (!equals(this.n25_1, tmp0_other_with_cast.n25_1))
      return false;
    if (!equals(this.o25_1, tmp0_other_with_cast.o25_1))
      return false;
    if (!equals(this.p25_1, tmp0_other_with_cast.p25_1))
      return false;
    return true;
  }
}
class Companion_13 {
  c2f(a, b) {
    // Inline function 'kotlin.math.min' call
    var a_0 = a.t25();
    var b_0 = b.t25();
    var tmp = Math.min(a_0, b_0);
    // Inline function 'kotlin.math.min' call
    var a_1 = a.v25();
    var b_1 = b.v25();
    var tmp_0 = Math.min(a_1, b_1);
    // Inline function 'kotlin.math.max' call
    var a_2 = a.u25();
    var b_2 = b.u25();
    var tmp_1 = Math.max(a_2, b_2);
    // Inline function 'kotlin.math.max' call
    var a_3 = a.w25();
    var b_3 = b.w25();
    var tmp$ret$3 = Math.max(a_3, b_3);
    return this.y2d(tmp, tmp_0, tmp_1, tmp$ret$3);
  }
  d2f(topLeft, bottomRight) {
    var size = bottomRight.g2f(topLeft);
    return RectangleInt.r2e(topLeft.e2f_1, topLeft.f2f_1, size.e2f_1, size.f2f_1);
  }
  y2d(left, top, right, bottom) {
    return this.d2f(Vector2I.h2f(left, top), Vector2I.h2f(right, bottom));
  }
}
class RectangleInt {
  static r2e(x, y, width, height) {
    var $this = createThis(this);
    $this.n2e_1 = x;
    $this.o2e_1 = y;
    $this.p2e_1 = width;
    $this.q2e_1 = height;
    return $this;
  }
  static i2f() {
    return this.r2e(0, 0, 0, 0);
  }
  j2f() {
    return imul(this.p2e_1, this.q2e_1);
  }
  t25() {
    return this.n2e_1;
  }
  v25() {
    return this.o2e_1;
  }
  u25() {
    return this.n2e_1 + this.p2e_1 | 0;
  }
  w25() {
    return this.o2e_1 + this.q2e_1 | 0;
  }
  k2f(left, top, right, bottom, clamped) {
    var left_0 = !clamped ? left : coerceIn(left, 0, this.p2e_1);
    var right_0 = !clamped ? right : coerceIn(right, 0, this.p2e_1);
    var top_0 = !clamped ? top : coerceIn(top, 0, this.q2e_1);
    var bottom_0 = !clamped ? bottom : coerceIn(bottom, 0, this.q2e_1);
    return Companion_instance_13.y2d(this.n2e_1 + left_0 | 0, this.o2e_1 + top_0 | 0, this.n2e_1 + right_0 | 0, this.o2e_1 + bottom_0 | 0);
  }
  toString() {
    return 'Rectangle(x=' + this.n2e_1 + ', y=' + this.o2e_1 + ', width=' + this.p2e_1 + ', height=' + this.q2e_1 + ')';
  }
  l2f() {
    return Companion_getInstance_12().u2d(this.n2e_1, this.o2e_1, this.p2e_1, this.q2e_1);
  }
  s2e(border) {
    return Companion_instance_13.y2d(this.t25() - border.r28_1 | 0, this.v25() - border.o28_1 | 0, this.u25() + border.p28_1 | 0, this.w25() + border.q28_1 | 0);
  }
  hashCode() {
    var result = this.n2e_1;
    result = imul(result, 31) + this.o2e_1 | 0;
    result = imul(result, 31) + this.p2e_1 | 0;
    result = imul(result, 31) + this.q2e_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectangleInt))
      return false;
    var tmp0_other_with_cast = other instanceof RectangleInt ? other : THROW_CCE();
    if (!(this.n2e_1 === tmp0_other_with_cast.n2e_1))
      return false;
    if (!(this.o2e_1 === tmp0_other_with_cast.o2e_1))
      return false;
    if (!(this.p2e_1 === tmp0_other_with_cast.p2e_1))
      return false;
    if (!(this.q2e_1 === tmp0_other_with_cast.q2e_1))
      return false;
    return true;
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_14 = this;
    this.m2f_1 = Scale.n2f(1.0, 1.0);
  }
}
class Scale {
  static g2d(scaleX, scaleY) {
    Companion_getInstance_14();
    var $this = createThis(this);
    $this.e2d_1 = scaleX;
    $this.f2d_1 = scaleY;
    return $this;
  }
  i2b() {
    return this.e2d_1 * 0.5 + this.f2d_1 * 0.5;
  }
  static o2f() {
    Companion_getInstance_14();
    return this.n2f(1.0, 1.0);
  }
  static p2f(scale) {
    Companion_getInstance_14();
    return this.g2d(scale, scale);
  }
  static q2f(scale) {
    Companion_getInstance_14();
    return this.p2f(scale);
  }
  static n2f(scaleX, scaleY) {
    Companion_getInstance_14();
    return this.g2d(scaleX, scaleY);
  }
  static r2f(scaleX, scaleY) {
    Companion_getInstance_14();
    return this.g2d(scaleX, scaleY);
  }
  toString() {
    return 'Scale(scaleX=' + this.e2d_1 + ', scaleY=' + this.f2d_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.e2d_1);
    result = imul(result, 31) + getNumberHashCode(this.f2d_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Scale))
      return false;
    var tmp0_other_with_cast = other instanceof Scale ? other : THROW_CCE();
    if (!equals(this.e2d_1, tmp0_other_with_cast.e2d_1))
      return false;
    if (!equals(this.f2d_1, tmp0_other_with_cast.f2d_1))
      return false;
    return true;
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_15 = this;
    var tmp = this;
    tmp.v2f_1 = new ScaleMode('COVER', ScaleMode$Companion$COVER$lambda);
    var tmp_0 = this;
    tmp_0.w2f_1 = new ScaleMode('SHOW_ALL', ScaleMode$Companion$SHOW_ALL$lambda);
    var tmp_1 = this;
    tmp_1.x2f_1 = new ScaleMode('EXACT', ScaleMode$Companion$EXACT$lambda);
    var tmp_2 = this;
    tmp_2.y2f_1 = new ScaleMode('NO_SCALE', ScaleMode$Companion$NO_SCALE$lambda);
  }
  z2f() {
    return this.x2f_1;
  }
}
class ScaleMode {
  constructor(name, transform) {
    Companion_getInstance_15();
    name = name === VOID ? null : name;
    this.y2e_1 = name;
    this.z2e_1 = transform;
  }
  toString() {
    return 'ScaleMode(' + this.y2e_1 + ')';
  }
  a2f(item, container) {
    return this.z2e_1(item, container);
  }
  a2g(item, container) {
    return toInt(this.z2e_1(toFloat(item), toFloat(container)));
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_16 = this;
    this.b2g_1 = Size2D.a2e(0.0, 0.0);
  }
}
class Size2D {
  static a2e(width, height) {
    Companion_getInstance_16();
    var $this = createThis(this);
    $this.h26_1 = width;
    $this.i26_1 = height;
    return $this;
  }
  static c2g() {
    Companion_getInstance_16();
    return this.a2e(0.0, 0.0);
  }
  static w2d(width, height) {
    Companion_getInstance_16();
    return this.a2e(width, height);
  }
  static j26(width, height) {
    Companion_getInstance_16();
    return this.a2e(width, height);
  }
  b2f(other) {
    return Size2D.a2e(this.h26_1 - other.h26_1, this.i26_1 - other.i26_1);
  }
  d2g(scale) {
    return Size2D.a2e(this.h26_1 * scale.e2d_1, this.i26_1 * scale.f2d_1);
  }
  e2g(s) {
    return Size2D.a2e(this.h26_1 * s, this.i26_1 * s);
  }
  t2d(s) {
    return this.e2g(s);
  }
  s2f(other) {
    return Scale.g2d(this.h26_1 / other.h26_1, this.i26_1 / other.i26_1);
  }
  toString() {
    return 'Size(width=' + get_niceStr(this.h26_1) + ', height=' + get_niceStr(this.i26_1) + ')';
  }
  dl() {
    return this.h26_1;
  }
  el() {
    return this.i26_1;
  }
  f2g(width, height) {
    return Size2D.a2e(width, height);
  }
  g2g(width, height, $super) {
    width = width === VOID ? this.h26_1 : width;
    height = height === VOID ? this.i26_1 : height;
    return $super === VOID ? this.f2g(width, height) : $super.f2g.call(this, width, height);
  }
  hashCode() {
    var result = getNumberHashCode(this.h26_1);
    result = imul(result, 31) + getNumberHashCode(this.i26_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Size2D))
      return false;
    var tmp0_other_with_cast = other instanceof Size2D ? other : THROW_CCE();
    if (!equals(this.h26_1, tmp0_other_with_cast.h26_1))
      return false;
    if (!equals(this.i26_1, tmp0_other_with_cast.i26_1))
      return false;
    return true;
  }
}
class SizeInt {
  static j2g(width, height) {
    var $this = createThis(this);
    $this.h2g_1 = width;
    $this.i2g_1 = height;
    return $this;
  }
  static k2g() {
    return this.j2g(0, 0);
  }
  toString() {
    return '' + this.h2g_1 + 'x' + this.i2g_1;
  }
  hashCode() {
    var result = this.h2g_1;
    result = imul(result, 31) + this.i2g_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SizeInt))
      return false;
    var tmp0_other_with_cast = other instanceof SizeInt ? other : THROW_CCE();
    if (!(this.h2g_1 === tmp0_other_with_cast.h2g_1))
      return false;
    if (!(this.i2g_1 === tmp0_other_with_cast.i2g_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_17 = this;
    this.e25_1 = Vector2D.s24(0.0, 0.0);
    this.f25_1 = Vector2D.s24(NaN, NaN);
    this.g25_1 = Vector2D.s24(-1.0, 0.0);
    this.h25_1 = Vector2D.s24(+1.0, 0.0);
    this.i25_1 = Vector2D.s24(0.0, +1.0);
    this.j25_1 = Vector2D.s24(0.0, -1.0);
    this.k25_1 = Vector2D.s24(0.0, -1.0);
    this.l25_1 = Vector2D.s24(0.0, +1.0);
  }
  l2g(a, b, up) {
    // Inline function 'korlibs.math.geom.Companion.between' call
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var x0 = a.q24_1;
    var y0 = a.r24_1;
    var x1 = b.q24_1;
    var y1 = b.r24_1;
    return Angle_between(x0, y0, x1, y1, up);
  }
  m2g(a, b, up, $super) {
    up = up === VOID ? this.i25_1 : up;
    return $super === VOID ? this.l2g(a, b, up) : $super.l2g.call(this, a, b, up).t24_1;
  }
  x2e(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  n2g(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  o2g(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  p2g(a, b) {
    return this.x2e(a.q24_1, a.r24_1, b.q24_1, b.r24_1);
  }
  u26(a, b) {
    return this.q2g(a.q24_1, a.r24_1, b.q24_1, b.r24_1);
  }
  q2g(x1, y1, x2, y2) {
    return square(this, x1 - x2) + square(this, y1 - y2);
  }
  r2g(ax, ay, bx, by) {
    return ax * by - bx * ay;
  }
  s2g(p1, p2) {
    return this.r2g(p1.q24_1, p1.r24_1, p2.q24_1, p2.r24_1);
  }
  m26(p1, p2) {
    // Inline function 'kotlin.math.min' call
    var a = p1.q24_1;
    var b = p2.q24_1;
    var tmp = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = p1.r24_1;
    var b_0 = p2.r24_1;
    var tmp$ret$1 = Math.min(a_0, b_0);
    return Vector2D.s24(tmp, tmp$ret$1);
  }
  e26(p1, p2, p3, p4) {
    return Vector2D.s24(minOf(p1.q24_1, new Float64Array([p2.q24_1, p3.q24_1, p4.q24_1])), minOf(p1.r24_1, new Float64Array([p2.r24_1, p3.r24_1, p4.r24_1])));
  }
  o26(p1, p2) {
    // Inline function 'kotlin.math.max' call
    var a = p1.q24_1;
    var b = p2.q24_1;
    var tmp = Math.max(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = p1.r24_1;
    var b_0 = p2.r24_1;
    var tmp$ret$1 = Math.max(a_0, b_0);
    return Vector2D.s24(tmp, tmp$ret$1);
  }
  f26(p1, p2, p3, p4) {
    return Vector2D.s24(maxOf(p1.q24_1, new Float64Array([p2.q24_1, p3.q24_1, p4.q24_1])), maxOf(p1.r24_1, new Float64Array([p2.r24_1, p3.r24_1, p4.r24_1])));
  }
}
class Vector2D {
  static s24(x, y) {
    Companion_getInstance_17();
    var $this = createThis(this);
    $this.q24_1 = x;
    $this.r24_1 = y;
    return $this;
  }
  static g2a(x, y) {
    Companion_getInstance_17();
    return this.s24(x, y);
  }
  static y27(x, y) {
    Companion_getInstance_17();
    return this.s24(x, y);
  }
  static w27() {
    Companion_getInstance_17();
    return this.s24(0.0, 0.0);
  }
  u2f() {
    // Inline function 'kotlin.math.min' call
    var a = this.q24_1;
    var b = this.r24_1;
    return Math.min(a, b);
  }
  t2f() {
    // Inline function 'kotlin.math.max' call
    var a = this.q24_1;
    var b = this.r24_1;
    return Math.max(a, b);
  }
  t2g(x, y) {
    // Inline function 'kotlin.math.hypot' call
    var x_0 = x - this.q24_1;
    var y_0 = y - this.r24_1;
    return hypot(x_0, y_0);
  }
  u2g(that) {
    return this.t2g(that.q24_1, that.r24_1);
  }
  a() {
    // Inline function 'kotlin.math.hypot' call
    var x = this.q24_1;
    var y = this.r24_1;
    return hypot(x, y);
  }
  v2g() {
    var x = this.q24_1;
    var y = this.r24_1;
    return x * x + y * y;
  }
  w2g() {
    // Inline function 'kotlin.math.hypot' call
    var x = this.q24_1;
    var y = this.r24_1;
    return hypot(x, y);
  }
  x2g() {
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale = 1.0 / this.w2g();
    return Vector2D.s24(this.q24_1 * scale, this.r24_1 * scale);
  }
  y2g() {
    return Vector2D.s24(-this.r24_1, this.q24_1);
  }
  z2g(other, epsilon) {
    return isAlmostEquals(this.q24_1, other.q24_1, epsilon) && isAlmostEquals(this.r24_1, other.r24_1, epsilon);
  }
  sw(other, epsilon) {
    return this.z2g(other instanceof Vector2D ? other : THROW_CCE(), epsilon);
  }
  a2h() {
    return '(' + get_niceStr(this.q24_1) + ', ' + get_niceStr(this.r24_1) + ')';
  }
  toString() {
    return this.a2h();
  }
  dl() {
    return this.q24_1;
  }
  el() {
    return this.r24_1;
  }
  hashCode() {
    var result = getNumberHashCode(this.q24_1);
    result = imul(result, 31) + getNumberHashCode(this.r24_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2D))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2D ? other : THROW_CCE();
    if (!equals(this.q24_1, tmp0_other_with_cast.q24_1))
      return false;
    if (!equals(this.r24_1, tmp0_other_with_cast.r24_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_18 = this;
    this.b2h_1 = new Vector4F(0.0, 0.0, 0.0, 0.0);
    this.c2h_1 = new Vector4F(1.0, 1.0, 1.0, 1.0);
  }
}
class Vector4F {
  constructor(x, y, z, w) {
    Companion_getInstance_18();
    this.d2h_1 = x;
    this.e2h_1 = y;
    this.f2h_1 = z;
    this.g2h_1 = w;
  }
  toString() {
    return 'Vector4(' + get_niceStr_0(this.d2h_1) + ', ' + get_niceStr_0(this.e2h_1) + ', ' + get_niceStr_0(this.f2h_1) + ', ' + get_niceStr_0(this.g2h_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.d2h_1);
    result = imul(result, 31) + getNumberHashCode(this.e2h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.f2h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.g2h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector4F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector4F ? other : THROW_CCE();
    if (!equals(this.d2h_1, tmp0_other_with_cast.d2h_1))
      return false;
    if (!equals(this.e2h_1, tmp0_other_with_cast.e2h_1))
      return false;
    if (!equals(this.f2h_1, tmp0_other_with_cast.f2h_1))
      return false;
    if (!equals(this.g2h_1, tmp0_other_with_cast.g2h_1))
      return false;
    return true;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_19 = this;
    this.h2h_1 = new Vector3F(NaN, NaN, NaN);
    this.i2h_1 = new Vector3F(0.0, 0.0, 0.0);
    this.j2h_1 = new Vector3F(1.0, 1.0, 1.0);
    this.k2h_1 = new Vector3F(0.0, 0.0, 1.0);
    this.l2h_1 = new Vector3F(0.0, 0.0, -1.0);
    this.m2h_1 = new Vector3F(-1.0, 0.0, 0.0);
    this.n2h_1 = new Vector3F(1.0, 0.0, 0.0);
    this.o2h_1 = new Vector3F(0.0, 1.0, 0.0);
    this.p2h_1 = new Vector3F(0.0, -1.0, 0.0);
  }
}
class Vector3F {
  constructor(x, y, z) {
    Companion_getInstance_19();
    this.q2h_1 = x;
    this.r2h_1 = y;
    this.s2h_1 = z;
  }
  toString() {
    return 'Vector3(' + get_niceStr_0(this.q2h_1) + ', ' + get_niceStr_0(this.r2h_1) + ', ' + get_niceStr_0(this.s2h_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.q2h_1);
    result = imul(result, 31) + getNumberHashCode(this.r2h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s2h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector3F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector3F ? other : THROW_CCE();
    if (!equals(this.q2h_1, tmp0_other_with_cast.q2h_1))
      return false;
    if (!equals(this.r2h_1, tmp0_other_with_cast.r2h_1))
      return false;
    if (!equals(this.s2h_1, tmp0_other_with_cast.s2h_1))
      return false;
    return true;
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_20 = this;
    this.t2h_1 = Vector2F.d2i(0.0, 0.0);
    this.u2h_1 = Vector2F.d2i(NaN, NaN);
    this.v2h_1 = Vector2F.d2i(-1.0, 0.0);
    this.w2h_1 = Vector2F.d2i(+1.0, 0.0);
    this.x2h_1 = Vector2F.d2i(0.0, +1.0);
    this.y2h_1 = Vector2F.d2i(0.0, -1.0);
    this.z2h_1 = Vector2F.d2i(0.0, -1.0);
    this.a2i_1 = Vector2F.d2i(0.0, +1.0);
  }
}
class Vector2F {
  static d2i(x, y) {
    Companion_getInstance_20();
    var $this = createThis(this);
    $this.b2i_1 = x;
    $this.c2i_1 = y;
    return $this;
  }
  static e2i(x, y) {
    Companion_getInstance_20();
    return this.d2i(x, y);
  }
  static f2i(x, y) {
    Companion_getInstance_20();
    return this.d2i(x, y);
  }
  static g2i() {
    Companion_getInstance_20();
    return this.d2i(0.0, 0.0);
  }
  a2h() {
    return '(' + get_niceStr_0(this.b2i_1) + ', ' + get_niceStr_0(this.c2i_1) + ')';
  }
  toString() {
    return this.a2h();
  }
  hashCode() {
    var result = getNumberHashCode(this.b2i_1);
    result = imul(result, 31) + getNumberHashCode(this.c2i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2F ? other : THROW_CCE();
    if (!equals(this.b2i_1, tmp0_other_with_cast.b2i_1))
      return false;
    if (!equals(this.c2i_1, tmp0_other_with_cast.c2i_1))
      return false;
    return true;
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_21 = this;
    this.h2i_1 = Vector2I.h2f(0, 0);
  }
}
class Vector2I {
  static h2f(x, y) {
    Companion_getInstance_21();
    var $this = createThis(this);
    $this.e2f_1 = x;
    $this.f2f_1 = y;
    return $this;
  }
  static i2i() {
    Companion_getInstance_21();
    return this.h2f(0, 0);
  }
  j2i(that) {
    return Vector2I.h2f(this.e2f_1 + that.e2f_1 | 0, this.f2f_1 + that.f2f_1 | 0);
  }
  g2f(that) {
    return Vector2I.h2f(this.e2f_1 - that.e2f_1 | 0, this.f2f_1 - that.f2f_1 | 0);
  }
  toString() {
    return '(' + this.e2f_1 + ', ' + this.f2f_1 + ')';
  }
  hashCode() {
    var result = this.e2f_1;
    result = imul(result, 31) + this.f2f_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2I))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2I ? other : THROW_CCE();
    if (!(this.e2f_1 === tmp0_other_with_cast.e2f_1))
      return false;
    if (!(this.f2f_1 === tmp0_other_with_cast.f2f_1))
      return false;
    return true;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function times(_this__u8e3s4, anchor) {
  // Inline function 'korlibs.math.geom.Vector2D.times' call
  var this_0 = toVector(_this__u8e3s4);
  var that = anchor.p24();
  return Vector2D.s24(this_0.q24_1 * that.q24_1, this_0.r24_1 * that.r24_1);
}
function _Angle___init__impl__g23q1m(radians) {
  return radians;
}
function _Angle___get_radians__impl__n00yt5($this) {
  return $this;
}
function _Angle___get_ratio__impl__ap3on4($this) {
  // Inline function 'korlibs.math.geom.Companion.radiansToRatio' call
  Companion_getInstance_0();
  var radians = _Angle___get_radians__impl__n00yt5($this);
  return _Ratio___init__impl__9mwvn2(radians / 6.283185307179586);
}
function _Angle___get_degrees__impl__qg56vw($this) {
  // Inline function 'korlibs.math.geom.Companion.radiansToDegrees' call
  Companion_getInstance_0();
  return _Angle___get_radians__impl__n00yt5($this) * 57.29577951308232;
}
function _Angle___get_cosine__impl__vprvmu($this) {
  // Inline function 'kotlin.math.cos' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.cos(x);
}
function _Angle___get_sine__impl__15nmyi($this) {
  // Inline function 'kotlin.math.sin' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.sin(x);
}
function _Angle___get_tangent__impl__vushdy($this) {
  // Inline function 'kotlin.math.tan' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.tan(x);
}
function Angle__cosine_impl_bgvzun($this, up) {
  return _Angle___get_cosine__impl__vprvmu(adjustFromUp($this, up));
}
function Angle__sine_impl_3l11xv($this, up) {
  return _Angle___get_sine__impl__15nmyi(adjustFromUp($this, up));
}
function _Angle___get_absoluteValue__impl__4qoakv($this) {
  // Inline function 'kotlin.math.absoluteValue' call
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var this_0 = _Angle___get_radians__impl__n00yt5($this);
  var tmp$ret$1 = Math.abs(this_0);
  return _Angle___init__impl__g23q1m(tmp$ret$1);
}
function Angle__div_impl_ut2btd($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 / scale);
}
function Angle__times_impl_v3s9y2($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 * scale);
}
function Angle__umod_impl_4wilf7($this, angle) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(angle);
  return _Angle___init__impl__g23q1m(umod(tmp, tmp$ret$1));
}
function Angle__div_impl_ut2btd_0($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  return tmp / _Angle___get_radians__impl__n00yt5(other);
}
function Angle__plus_impl_26v37k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp + tmp$ret$1);
}
function Angle__minus_impl_xeau7k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp - tmp$ret$1);
}
function Angle__unaryMinus_impl_7901fr($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(-tmp$ret$0);
}
function Angle__unaryPlus_impl_eyi5pl($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(+tmp$ret$0);
}
function Angle__isAlmostEquals_impl_201sgt($this, other, epsilon) {
  return isAlmostEquals(_Angle___get_radians__impl__n00yt5($this), _Angle___get_radians__impl__n00yt5(other), epsilon);
}
function Angle__isAlmostEquals_impl_201sgt_0($this, other, epsilon) {
  return Angle__isAlmostEquals_impl_201sgt($this.t24_1, other instanceof Angle ? other.t24_1 : THROW_CCE(), epsilon);
}
function _Angle___get_normalized__impl__9s30ys($this) {
  // Inline function 'korlibs.math.geom.Companion.fromRatio' call
  Companion_getInstance_0();
  var ratio = umod(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4($this)), 1.0);
  // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
  var ratio_0 = toRatio(ratio);
  var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function Angle__compareTo_impl_a0hfds($this, other) {
  return Ratio__compareTo_impl_z2ienc(_Angle___get_ratio__impl__ap3on4($this), _Angle___get_ratio__impl__ap3on4(other));
}
function Angle__compareTo_impl_a0hfds_0($this, other) {
  return Angle__compareTo_impl_a0hfds($this.t24_1, other instanceof Angle ? other.t24_1 : THROW_CCE());
}
function Angle__toString_impl_786qky($this) {
  return get_niceStr(roundDecimalPlaces(_Angle___get_degrees__impl__qg56vw($this), 2)) + '.degrees';
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function Angle__hashCode_impl_szcndt($this) {
  return getNumberHashCode($this);
}
function Angle__equals_impl_zcf5mt($this, other) {
  if (!(other instanceof Angle))
    return false;
  var tmp0_other_with_cast = other instanceof Angle ? other.t24_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function get_degrees(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromDegrees' call
  // Inline function 'korlibs.math.geom.Companion.degreesToRadians' call
  Companion_getInstance_0();
  var tmp$ret$0 = _this__u8e3s4 * 0.017453292519943295;
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function get_radians(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_0();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function interpolateAngleDenormalized(_this__u8e3s4, l, r) {
  return interpolateAngle(_this__u8e3s4, l, r, false);
}
function get_radians_0(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_0();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function adjustFromUp(_this__u8e3s4, up) {
  Companion_instance_10.d25(up);
  return up.r24_1 > 0 ? _this__u8e3s4 : Angle__unaryMinus_impl_7901fr(_this__u8e3s4);
}
function Angle_between(x0, y0, x1, y1, up) {
  up = up === VOID ? Companion_getInstance_17().i25_1 : up;
  // Inline function 'korlibs.math.geom.Companion.atan2' call
  Companion_getInstance_0();
  var x = y1 - y0;
  var y = x1 - x0;
  var up_0 = Companion_getInstance_17().i25_1;
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  // Inline function 'kotlin.math.atan2' call
  var radians = Math.atan2(x, y);
  var tmp$ret$1 = _Angle___init__impl__g23q1m(radians);
  var angle = adjustFromUp(tmp$ret$1, up_0);
  return adjustFromUp(Angle__compareTo_impl_a0hfds(angle, Companion_getInstance_0().v24_1) < 0 ? Angle__plus_impl_26v37k(angle, Companion_getInstance_0().z24_1) : angle, up);
}
function interpolateAngle(_this__u8e3s4, l, r, minimizeAngle) {
  return _interpolateAngleAny(_this__u8e3s4, l, r, minimizeAngle);
}
function _interpolateAngleAny(ratio, l, r, minimizeAngle) {
  minimizeAngle = minimizeAngle === VOID ? true : minimizeAngle;
  if (!minimizeAngle) {
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_0();
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = interpolate(ratio, _Angle___get_ratio__impl__ap3on4(l), _Angle___get_ratio__impl__ap3on4(r));
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    return _Angle___init__impl__g23q1m(tmp$ret$0);
  }
  var ln = _Angle___get_normalized__impl__9s30ys(l);
  var rn = _Angle___get_normalized__impl__9s30ys(r);
  var tmp;
  if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(Angle__minus_impl_xeau7k(rn, ln)), Companion_getInstance_0().x24_1) <= 0) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(ln), _Angle___get_radians__impl__n00yt5(rn));
    tmp = _Angle___init__impl__g23q1m(radians);
  } else if (Angle__compareTo_impl_a0hfds(ln, rn) < 0) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians_0 = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(Angle__plus_impl_26v37k(ln, Companion_getInstance_0().z24_1)), _Angle___get_radians__impl__n00yt5(rn));
    var tmp$ret$3 = _Angle___init__impl__g23q1m(radians_0);
    tmp = _Angle___get_normalized__impl__9s30ys(tmp$ret$3);
  } else {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians_1 = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(ln), _Angle___get_radians__impl__n00yt5(Angle__plus_impl_26v37k(rn, Companion_getInstance_0().z24_1)));
    var tmp$ret$4 = _Angle___init__impl__g23q1m(radians_1);
    tmp = _Angle___get_normalized__impl__9s30ys(tmp$ret$4);
  }
  return tmp;
}
function _BoundsBuilder___init__impl__g6dprh(bounds) {
  return bounds;
}
function _BoundsBuilder___get_bounds__impl__s1l1gx($this) {
  return $this;
}
function _BoundsBuilder___get_isEmpty__impl__e9t785($this) {
  return _BoundsBuilder___get_bounds__impl__s1l1gx($this).r25();
}
function _BoundsBuilder___get_isNotEmpty__impl__w6rbsy($this) {
  return _BoundsBuilder___get_bounds__impl__s1l1gx($this).s25();
}
function _BoundsBuilder___get_xmin__impl__o2sib0($this) {
  // Inline function 'kotlin.math.min' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).t25();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).u25();
  return Math.min(a, b);
}
function _BoundsBuilder___get_xmax__impl__gsz0km($this) {
  // Inline function 'kotlin.math.max' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).t25();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).u25();
  return Math.max(a, b);
}
function _BoundsBuilder___get_ymin__impl__5n2e8j($this) {
  // Inline function 'kotlin.math.min' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).v25();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).w25();
  return Math.min(a, b);
}
function _BoundsBuilder___get_ymax__impl__oia4uz($this) {
  // Inline function 'kotlin.math.max' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).v25();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).w25();
  return Math.max(a, b);
}
function BoundsBuilder__xminOr_impl_k3l1m2($this, default_0) {
  return _BoundsBuilder___get_hasPoints__impl__6mwi9x($this) ? _BoundsBuilder___get_xmin__impl__o2sib0($this) : default_0;
}
function _BoundsBuilder___get_hasPoints__impl__6mwi9x($this) {
  return _BoundsBuilder___get_isNotEmpty__impl__w6rbsy($this);
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function BoundsBuilder__plus_impl_cz7f7x($this, p) {
  if (_BoundsBuilder___get_bounds__impl__s1l1gx($this).r25())
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_12().k26(p, Size2D.j26(0, 0)));
  return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_12().g26(Companion_getInstance_17().m26(_BoundsBuilder___get_bounds__impl__s1l1gx($this).l26(), p), Companion_getInstance_17().o26(_BoundsBuilder___get_bounds__impl__s1l1gx($this).n26(), p)));
}
function BoundsBuilder__plus_impl_cz7f7x_0($this, rect) {
  if (rect == null)
    return $this;
  if (rect.r25())
    return $this;
  return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x($this, rect.l26()), rect.n26());
}
function BoundsBuilder__plus_impl_cz7f7x_1($this, p) {
  var bb = $this;
  var inductionVariable = 0;
  var last = p.e1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, p.d1(n));
    }
     while (inductionVariable < last);
  return bb;
}
function BoundsBuilder__plus_impl_cz7f7x_2($this, rects) {
  var bb = $this;
  var _iterator__ex2g4s = rects.a1();
  while (_iterator__ex2g4s.b1()) {
    var it = _iterator__ex2g4s.c1();
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, it);
  }
  return bb;
}
function BoundsBuilder__boundsOrNull_impl_se9lyg($this) {
  return _BoundsBuilder___get_isEmpty__impl__e9t785($this) ? null : _BoundsBuilder___get_bounds__impl__s1l1gx($this);
}
function BoundsBuilder__toString_impl_fmvxh7($this) {
  return 'BoundsBuilder(bounds=' + $this.toString() + ')';
}
function BoundsBuilder__hashCode_impl_649zbo($this) {
  return $this.hashCode();
}
function BoundsBuilder__equals_impl_jngfjs($this, other) {
  if (!(other instanceof BoundsBuilder))
    return false;
  var tmp0_other_with_cast = other instanceof BoundsBuilder ? other.p26_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  if (Companion_instance_5 === VOID)
    new Companion_5();
  return Companion_instance_5;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  if (Companion_instance_6 === VOID)
    new Companion_6();
  return Companion_instance_6;
}
var Companion_instance_7;
function Companion_getInstance_7() {
  if (Companion_instance_7 === VOID)
    new Companion_7();
  return Companion_instance_7;
}
var MatrixType_IDENTITY_instance;
var MatrixType_TRANSLATE_instance;
var MatrixType_SCALE_instance;
var MatrixType_SCALE_TRANSLATE_instance;
var MatrixType_COMPLEX_instance;
var MatrixType_entriesInitialized;
function MatrixType_initEntries() {
  if (MatrixType_entriesInitialized)
    return Unit_instance;
  MatrixType_entriesInitialized = true;
  MatrixType_IDENTITY_instance = new MatrixType('IDENTITY', 0, 1, false, false, false);
  MatrixType_TRANSLATE_instance = new MatrixType('TRANSLATE', 1, 2, false, false, true);
  MatrixType_SCALE_instance = new MatrixType('SCALE', 2, 3, false, true, false);
  MatrixType_SCALE_TRANSLATE_instance = new MatrixType('SCALE_TRANSLATE', 3, 4, false, true, true);
  MatrixType_COMPLEX_instance = new MatrixType('COMPLEX', 4, 5, true, true, true);
}
var Companion_instance_8;
function Companion_getInstance_8() {
  if (Companion_instance_8 === VOID)
    new Companion_8();
  return Companion_instance_8;
}
function MatrixType_IDENTITY_getInstance() {
  MatrixType_initEntries();
  return MatrixType_IDENTITY_instance;
}
function MatrixType_TRANSLATE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_TRANSLATE_instance;
}
function MatrixType_SCALE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_SCALE_instance;
}
function MatrixType_SCALE_TRANSLATE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_SCALE_TRANSLATE_instance;
}
function MatrixType_COMPLEX_getInstance() {
  MatrixType_initEntries();
  return MatrixType_COMPLEX_instance;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  if (Companion_instance_9 === VOID)
    new Companion_9();
  return Companion_instance_9;
}
function ortho(_this__u8e3s4, rect, near, far) {
  near = near === VOID ? 0.0 : near;
  far = far === VOID ? 1.0 : far;
  return Companion_getInstance_9().a2d(rect.t25(), rect.u25(), rect.w25(), rect.v25(), near, far);
}
function scaled(_this__u8e3s4, scale) {
  return _this__u8e3s4.w29(scale.e2d_1, scale.f2d_1);
}
function get_scale(_this__u8e3s4) {
  return Scale.g2d(_this__u8e3s4.y2a_1, _this__u8e3s4.z2a_1);
}
var Orientation_CLOCK_WISE_instance;
var Orientation_COUNTER_CLOCK_WISE_instance;
var Orientation_COLLINEAR_instance;
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
var Orientation_entriesInitialized;
function Orientation_initEntries() {
  if (Orientation_entriesInitialized)
    return Unit_instance;
  Orientation_entriesInitialized = true;
  Orientation_CLOCK_WISE_instance = new Orientation('CLOCK_WISE', 0, 1);
  Orientation_COUNTER_CLOCK_WISE_instance = new Orientation('COUNTER_CLOCK_WISE', 1, -1);
  Orientation_COLLINEAR_instance = new Orientation('COLLINEAR', 2, 0);
}
var Companion_instance_11;
function Companion_getInstance_11() {
  if (Companion_instance_11 === VOID)
    new Companion_11();
  return Companion_instance_11;
}
var Companion_instance_12;
function Companion_getInstance_12() {
  if (Companion_instance_12 === VOID)
    new Companion_12();
  return Companion_instance_12;
}
function outerCircle(_this__u8e3s4) {
  var centerX = _this__u8e3s4.g2e();
  var centerY = _this__u8e3s4.h2e();
  return new Circle(_this__u8e3s4.i2e(), Companion_getInstance_17().x2e(centerX, centerY, _this__u8e3s4.u25(), _this__u8e3s4.v25()));
}
function place(_this__u8e3s4, item, anchor, scale) {
  var outSize = scale.a2f(item, _this__u8e3s4.e1());
  var p = times(_this__u8e3s4.e1().b2f(outSize), anchor);
  return Companion_getInstance_12().k26(p, outSize);
}
var Companion_instance_13;
function Companion_getInstance_13() {
  return Companion_instance_13;
}
var Companion_instance_14;
function Companion_getInstance_14() {
  if (Companion_instance_14 === VOID)
    new Companion_14();
  return Companion_instance_14;
}
function toVector2(_this__u8e3s4) {
  return Vector2D.s24(_this__u8e3s4.e2d_1, _this__u8e3s4.f2d_1);
}
function ScaleMode$Companion$COVER$lambda(i, c) {
  return i.t2d(toVector2(c.s2f(i)).t2f());
}
function ScaleMode$Companion$SHOW_ALL$lambda(i, c) {
  return i.t2d(toVector2(c.s2f(i)).u2f());
}
function ScaleMode$Companion$EXACT$lambda(i, c) {
  return c;
}
function ScaleMode$Companion$NO_SCALE$lambda(i, c) {
  return i;
}
var Companion_instance_15;
function Companion_getInstance_15() {
  if (Companion_instance_15 === VOID)
    new Companion_15();
  return Companion_instance_15;
}
var Companion_instance_16;
function Companion_getInstance_16() {
  if (Companion_instance_16 === VOID)
    new Companion_16();
  return Companion_instance_16;
}
function toFloat(_this__u8e3s4) {
  return Size2D.w2d(_this__u8e3s4.h2g_1, _this__u8e3s4.i2g_1);
}
function toInt(_this__u8e3s4) {
  return SizeInt.j2g(numberToInt(_this__u8e3s4.h26_1), numberToInt(_this__u8e3s4.i26_1));
}
function times_0(_this__u8e3s4, other) {
  return Vector2D.s24(_this__u8e3s4.q24_1 * other.h26_1, _this__u8e3s4.r24_1 * other.i26_1);
}
function div(_this__u8e3s4, other) {
  return Vector2D.s24(_this__u8e3s4.q24_1 / other.h26_1, _this__u8e3s4.r24_1 / other.i26_1);
}
function toSize(_this__u8e3s4) {
  return Size2D.a2e(_this__u8e3s4.q24_1, _this__u8e3s4.r24_1);
}
function toVector(_this__u8e3s4) {
  return Vector2D.s24(_this__u8e3s4.h26_1, _this__u8e3s4.i26_1);
}
function transformX(_this__u8e3s4, m) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (m.r25()) {
      tmp$ret$0 = _this__u8e3s4;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.s24(m.o29(_this__u8e3s4.q24_1, _this__u8e3s4.r24_1), m.r29(_this__u8e3s4.q24_1, _this__u8e3s4.r24_1));
  }
  return tmp$ret$0.q24_1;
}
function transformY(_this__u8e3s4, m) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (m.r25()) {
      tmp$ret$0 = _this__u8e3s4;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.s24(m.o29(_this__u8e3s4.q24_1, _this__u8e3s4.r24_1), m.r29(_this__u8e3s4.q24_1, _this__u8e3s4.r24_1));
  }
  return tmp$ret$0.r24_1;
}
function square($this, x) {
  return x * x;
}
var Companion_instance_17;
function Companion_getInstance_17() {
  if (Companion_instance_17 === VOID)
    new Companion_17();
  return Companion_instance_17;
}
function toInt_0(_this__u8e3s4) {
  return Vector2I.h2f(numberToInt(_this__u8e3s4.q24_1), numberToInt(_this__u8e3s4.r24_1));
}
var Companion_instance_18;
function Companion_getInstance_18() {
  if (Companion_instance_18 === VOID)
    new Companion_18();
  return Companion_instance_18;
}
var Companion_instance_19;
function Companion_getInstance_19() {
  if (Companion_instance_19 === VOID)
    new Companion_19();
  return Companion_instance_19;
}
var Companion_instance_20;
function Companion_getInstance_20() {
  if (Companion_instance_20 === VOID)
    new Companion_20();
  return Companion_instance_20;
}
function toInt_1(_this__u8e3s4) {
  return Vector2I.h2f(numberToInt(_this__u8e3s4.b2i_1), numberToInt(_this__u8e3s4.c2i_1));
}
var Companion_instance_21;
function Companion_getInstance_21() {
  if (Companion_instance_21 === VOID)
    new Companion_21();
  return Companion_instance_21;
}
function toFloat_0(_this__u8e3s4) {
  return Vector2F.f2i(_this__u8e3s4.e2f_1, _this__u8e3s4.f2f_1);
}
function toDouble(_this__u8e3s4) {
  return Vector2D.y27(_this__u8e3s4.e2f_1, _this__u8e3s4.f2f_1);
}
function interpolate_1(_this__u8e3s4, l, r) {
  return Vector2D.s24(interpolate_0(_this__u8e3s4, l.q24_1, r.q24_1), interpolate_0(_this__u8e3s4, l.r24_1, r.r24_1));
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(Anchor2D, 'Anchor2D');
initMetadataForCompanion(Companion_0);
protoOf(Angle).tw = isAlmostEquals$default;
initMetadataForClass(Angle, 'Angle', VOID, VOID, [Comparable, IsAlmostEquals]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(BoundsBuilder, 'BoundsBuilder');
initMetadataForCompanion(Companion_2);
initMetadataForClass(Circle, 'Circle');
initMetadataForClass(IPointList$Sublist$listIterator$1);
initMetadataForClass(Sublist, 'Sublist', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_3);
initMetadataForInterface(IDoubleVectorList, 'IDoubleVectorList', VOID, VOID, [IsAlmostEquals]);
initMetadataForInterface(IPointList, 'IPointList', VOID, VOID, [IDoubleVectorList, KtList]);
initMetadataForCompanion(Companion_4);
initMetadataForClass(Line2D, 'Line2D', Line2D.v27);
initMetadataForCompanion(Companion_5);
protoOf(Margin).tw = isAlmostEquals$default;
initMetadataForClass(Margin, 'Margin', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(MarginInt, 'MarginInt');
initMetadataForCompanion(Companion_7);
protoOf(Matrix).tw = isAlmostEquals$default;
initMetadataForClass(Matrix, 'Matrix', VOID, VOID, [IsAlmostEquals]);
initMetadataForClass(MatrixType, 'MatrixType');
initMetadataForCompanion(Companion_8);
protoOf(MatrixTransform).tw = isAlmostEquals$default;
initMetadataForClass(MatrixTransform, 'MatrixTransform', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Matrix4, 'Matrix4', Matrix4.f2c);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Orientation, 'Orientation');
initMetadataForCompanion(Companion_11);
initMetadataForClass(RectCorners, 'RectCorners');
initMetadataForCompanion(Companion_12);
protoOf(Rectangle).tw = isAlmostEquals$default;
initMetadataForClass(Rectangle, 'Rectangle', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_13);
initMetadataForClass(RectangleInt, 'RectangleInt', RectangleInt.i2f);
initMetadataForCompanion(Companion_14);
initMetadataForClass(Scale, 'Scale', Scale.o2f);
initMetadataForCompanion(Companion_15);
initMetadataForClass(ScaleMode, 'ScaleMode');
initMetadataForCompanion(Companion_16);
initMetadataForClass(Size2D, 'Size2D', Size2D.c2g);
initMetadataForClass(SizeInt, 'SizeInt', SizeInt.k2g);
initMetadataForCompanion(Companion_17);
protoOf(Vector2D).tw = isAlmostEquals$default;
initMetadataForClass(Vector2D, 'Vector2D', Vector2D.w27, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_18);
initMetadataForClass(Vector4F, 'Vector4F');
initMetadataForCompanion(Companion_19);
initMetadataForClass(Vector3F, 'Vector3F');
initMetadataForCompanion(Companion_20);
initMetadataForClass(Vector2F, 'Vector2F', Vector2F.g2i);
initMetadataForCompanion(Companion_21);
initMetadataForClass(Vector2I, 'Vector2I', Vector2I.i2i);
//endregion
//region block: init
Companion_instance_2 = new Companion_2();
Companion_instance_3 = new Companion_3();
Companion_instance_10 = new Companion_10();
Companion_instance_13 = new Companion_13();
//endregion
//region block: exports
export {
  MatrixType_IDENTITY_getInstance as MatrixType_IDENTITY_getInstance26n3n49ggvwm4,
  _Angle___init__impl__g23q1m as _Angle___init__impl__g23q1m36yxttgnpy5tv,
  _Angle___get_absoluteValue__impl__4qoakv as _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle,
  Angle__compareTo_impl_a0hfds as Angle__compareTo_impl_a0hfds24obl4qqhxk1t,
  _Angle___get_cosine__impl__vprvmu as _Angle___get_cosine__impl__vprvmu3ab5uwcliuboq,
  Angle__cosine_impl_bgvzun as Angle__cosine_impl_bgvzun1b2925dagclby,
  _Angle___get_degrees__impl__qg56vw as _Angle___get_degrees__impl__qg56vw2n539uvc01e1n,
  Angle__div_impl_ut2btd as Angle__div_impl_ut2btd1qmy7ftoy1opp,
  Angle__div_impl_ut2btd_0 as Angle__div_impl_ut2btd19ndx9mxcgcss,
  Angle__hashCode_impl_szcndt as Angle__hashCode_impl_szcndtx0rhatnvuhb1,
  Angle__minus_impl_xeau7k as Angle__minus_impl_xeau7ko02ca30grn4a,
  _Angle___get_normalized__impl__9s30ys as _Angle___get_normalized__impl__9s30ys1q15xt9x23bx,
  Angle__plus_impl_26v37k as Angle__plus_impl_26v37karx983dsduoy,
  _Angle___get_radians__impl__n00yt5 as _Angle___get_radians__impl__n00yt518seywpfbf9fr,
  _Angle___get_ratio__impl__ap3on4 as _Angle___get_ratio__impl__ap3on435dv91f5cbp85,
  _Angle___get_sine__impl__15nmyi as _Angle___get_sine__impl__15nmyi39oh4tio4auz1,
  Angle__sine_impl_3l11xv as Angle__sine_impl_3l11xv3pgl8zzgp52i0,
  _Angle___get_tangent__impl__vushdy as _Angle___get_tangent__impl__vushdy2zy6w59e4l7qg,
  Angle__times_impl_v3s9y2 as Angle__times_impl_v3s9y21yznxo5bj1uj7,
  Angle__umod_impl_4wilf7 as Angle__umod_impl_4wilf71vq5gai237g1r,
  Angle__unaryMinus_impl_7901fr as Angle__unaryMinus_impl_7901fruk5m76f5kg06,
  Angle__unaryPlus_impl_eyi5pl as Angle__unaryPlus_impl_eyi5plrfyn5fslhvdp,
  _BoundsBuilder___get_bounds__impl__s1l1gx as _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i,
  BoundsBuilder__boundsOrNull_impl_se9lyg as BoundsBuilder__boundsOrNull_impl_se9lyg1z0iqowyff423,
  BoundsBuilder__hashCode_impl_649zbo as BoundsBuilder__hashCode_impl_649zbo2cbmgnd4y2see,
  BoundsBuilder__plus_impl_cz7f7x as BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3,
  BoundsBuilder__plus_impl_cz7f7x_2 as BoundsBuilder__plus_impl_cz7f7xqnc8b6uzo82y,
  BoundsBuilder__plus_impl_cz7f7x_1 as BoundsBuilder__plus_impl_cz7f7xiu6sbkxslhhl,
  BoundsBuilder__plus_impl_cz7f7x_0 as BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm,
  BoundsBuilder__toString_impl_fmvxh7 as BoundsBuilder__toString_impl_fmvxh7qh65bafrb2p,
  _BoundsBuilder___get_xmax__impl__gsz0km as _BoundsBuilder___get_xmax__impl__gsz0km31n4zf6la54qa,
  _BoundsBuilder___get_xmin__impl__o2sib0 as _BoundsBuilder___get_xmin__impl__o2sib0fqg01yornfcx,
  BoundsBuilder__xminOr_impl_k3l1m2 as BoundsBuilder__xminOr_impl_k3l1m233j5xey4uzzri,
  _BoundsBuilder___get_ymax__impl__oia4uz as _BoundsBuilder___get_ymax__impl__oia4uz2kb33iwdnvg1r,
  _BoundsBuilder___get_ymin__impl__5n2e8j as _BoundsBuilder___get_ymin__impl__5n2e8j1x2fwruhjr6r5,
  Companion_getInstance as Companion_getInstanceeqp3ibr2vvu9,
  Companion_getInstance_0 as Companion_getInstance3rze5babd97ff,
  Companion_getInstance_1 as Companion_getInstance2yu48324co92b,
  Companion_getInstance_5 as Companion_getInstance3la8ioxhl91va,
  Companion_getInstance_6 as Companion_getInstancenbeyvbsm21qs,
  Companion_getInstance_7 as Companion_getInstance1zxby1ngivg0d,
  Companion_getInstance_9 as Companion_getInstance3qti4zygy7usz,
  Companion_getInstance_11 as Companion_getInstance3lu3946d91kk8,
  Companion_getInstance_12 as Companion_getInstance1bdwtq6rroayu,
  Companion_instance_13 as Companion_instanceu31qrc8c1r0r,
  Companion_getInstance_15 as Companion_getInstance23o88a0u6ly94,
  Companion_getInstance_16 as Companion_getInstance1j5nd3fbu9uao,
  Companion_getInstance_17 as Companion_getInstancewdpvtc2ehxkt,
  Companion_getInstance_19 as Companion_getInstance1yq7a1f60lp2k,
  Anchor2D as Anchor2D3ucppq7m9n3z8,
  Angle_between as Angle_between72970e1vlen9,
  Angle as Angle2itorpob18n08,
  BoundsBuilder as BoundsBuilder162uwsje56mvu,
  isAlmostEquals_0 as isAlmostEquals2qd88bwpjj4z5,
  isNotEmpty as isNotEmptyrwyeygz7izwg,
  IDoubleVectorList as IDoubleVectorListoa05cse3he2p,
  containsAll as containsAll194lepx84fvib,
  indexOf as indexOf3tp8bzbv46hci,
  iterator as iterator1sm8hwbj0nmg8,
  listIterator as listIteratorrk3szyua4uzm,
  listIterator_0 as listIterator3ooh2yjav3kr9,
  subList as subList2funs4qwcrhhq,
  IPointList as IPointListz7raskb2mrxa,
  Line2D as Line2D2pf35pcx71ncp,
  MarginInt as MarginInt3jiec8xsxkfd,
  Margin as Marginzmgz0t8x8vn,
  Matrix4 as Matrix43neeu8v4zk4i7,
  MatrixTransform as MatrixTransform1wlsrhxt7473v,
  Matrix as Matrix1p940sdz227jj,
  RectCorners as RectCorners2yrtl8r42p5bs,
  RectangleInt as RectangleInt3lmu13ytuf5lk,
  Rectangle as Rectangle3q03woyn9k8x1,
  Scale as Scale2cm697xlulcp5,
  Size2D as Size2Dum5ayuyhhau7,
  SizeInt as SizeInte6w85oa6mz6v,
  Vector2D as Vector2D378fe5rov8fgw,
  Vector2F as Vector2F2yb91r49vy4m7,
  Vector2I as Vector2I2k5512l4eeahb,
  Vector4F as Vector4F1clr35ctch8js,
  adjustFromUp as adjustFromUp1ak85cceintt4,
  get_degrees as get_degrees3czcd4ojw4i,
  div as div919pico60rxu,
  interpolateAngleDenormalized as interpolateAngleDenormalized1hkwzk523mo1c,
  ortho as orthow9c0o91bw54n,
  outerCircle as outerCircle30hn5vvbpz9gu,
  place as place35kwuvwdaw5nl,
  get_radians as get_radians391vbqqjsolq6,
  get_scale as get_scale17gmsnxnqj6j9,
  scaled as scaled2eehd42i2trq9,
  times_0 as timesatqrmkwmiu2z,
  toDouble as toDouble2d46ijanub8on,
  toFloat_0 as toFloat3vwgbpbd3tigk,
  toFloat as toFloat3b315y36g90cd,
  toInt as toIntp2twe4onfbic,
  toInt_0 as toIntu0rc68akxu7a,
  toInt_1 as toInt1pmw4ml9b064d,
  transformX as transformX33nszy4vzqsfy,
  transformY as transformY3ktoxhxwkzwk1,
  interpolate_1 as interpolatewhd2sgxffql5,
};
//endregion
